<template>
  <div class="app-inner">
    <div class="searchTitleDiv">
      <el-row>
        <div class="stateDiv">
          <!-- &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; -->
          <p class="searchText">室号&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>
          <el-input v-model="searchFrom.roomName" placeholder="请输入" clearable class="inputDiv"></el-input>
        </div>
        <div class="stateDiv">
          <p class="searchText">园区 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>
          <el-select v-model="searchFrom.parkCode" placeholder="请选择" @change="handleParkCode" clearable>
            <el-option v-for="item in basePackInfoList" :key="item.parkCode" :label="item.parkName"
              :value="item.parkCode">
            </el-option>
          </el-select>
        </div>
        <div class="stateDiv">
          <p class="searchText">楼宇&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>
          <el-select v-model="searchFrom.buildingId" placeholder="请选择" class="inputDiv" clearable>
            <el-option v-for="item in buildingList" :key="item.id" :label="item.buildingName" :value="item.id">
            </el-option>
          </el-select>
        </div>
      </el-row>
      <el-row>
        <div class="stateDiv">
          <p class="searchText">承租状态</p>
          <el-select v-model="searchFrom.rentType" placeholder="请选择" class="inputDiv" clearable>
            <el-option v-for="item in rentTypeOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="stateDiv">
          <p class="searchText">承租企业</p>
          <el-select v-model="searchFrom.rentCompanyId" placeholder="请选择" clearable filterable >
            <el-option v-for="item in baseRenterCompanyList" :key="item.renterId" :label="item.renterCompanyName"
              :value="item.renterId">
            </el-option>
          </el-select>
        </div>
        <div class="stateDiv">
          <p class="searchText">楼宇地址</p>
          <el-input v-model="searchFrom.buildingAddr" placeholder="请输入" clearable class="inputDiv"></el-input>
        </div>
        <el-button class="searchBtn" type="primary" @click="getData">查 询</el-button>
            <el-button class="searchBtn" type="primary" @click="exportBuildData">导出</el-button>
        <el-button class="searchBtn" type="warning" @click="addFormData">新增房屋</el-button>
      </el-row>
    </div>
    <!--      列表-->
    <div class="table">
      <div class="searchList">
        <el-table v-loading="loading" :data="tableData" :default-sort="{ prop: 'id', order: 'descending' }"
          style="width: 100%" :highlight-current-row="false" :summary-method="getSummaries" show-summary
          :header-cell-style="{ background: '#F4F7FA', color: '#606266' }">
          <template v-for="(item, index) in tableColumns">
            <el-table-column v-if="item.prop === 'rentEndDate'" :key="index" :prop="item.prop" :label="item.label"
              width="190px">
              <template slot-scope="scope">
                <div v-if="getMonthsNum(scope.row).num === 0 && getMonthsNum(scope.row).type === 'day'"
                  style="color:#f40909">{{ scope.row.rentEndDate }}(已到期)</div>
                <div v-if="getMonthsNum(scope.row).num > 0 && getMonthsNum(scope.row).type === 'day'"
                  style="color:#f40909">{{ scope.row.rentEndDate }}(三个月内到期)</div>
                  <div v-if="getMonthsNum(scope.row).num < 0 && getMonthsNum(scope.row).type === 'day'">{{ scope.row.rentEndDate }}</div>
                <div
                  v-if="getMonthsNum(scope.row).num >= 0 && getMonthsNum(scope.row).num <= 3 && getMonthsNum(scope.row).type === 'month'"
                  style="color:#f40909;">{{ scope.row.rentEndDate }}(三个月内到期)</div>
                <div
                  v-if="getMonthsNum(scope.row).num > 3 && getMonthsNum(scope.row).num <= 6 && getMonthsNum(scope.row).type === 'month'"
                  style="color:#e6a700">{{ scope.row.rentEndDate }}(六个月内到期)</div>
                  <div
                  v-if="getMonthsNum(scope.row).num > 6 && getMonthsNum(scope.row).type === 'month'">{{ scope.row.rentEndDate }}</div>
                <!-- <div v-if="getMonthsNum(scope.row) <= 3 && getMonthsNum(scope.row) > 0" style="color:#f40909">{{
                scope.row.rentEndDate }}(三个月内到期)</div>
                <div v-if="getMonthsNum(scope.row) <= 6 && getMonthsNum(scope.row) > 3" style="color:#f40909">
                  {{ scope.row.rentEndDate }}(6个月内到期)</div> -->
                <div v-if="getMonthsNum(scope.row).num === -1">{{ scope.row.rentEndDate }}</div>
              </template>
            </el-table-column>
            <el-table-column v-else-if="item.prop === 'roomName'" :key="index" :prop="item.prop" :label="item.label" :formatter="item.formatter"
              :width="item.width">
              <template slot-scope="scope" class="tableButton">
                <el-link class="tableBtn" type="primary" @click="viewOrHandleDetail(scope.row)" size="small">{{scope.row.roomName}}</el-link>
              </template>
            </el-table-column>
            <el-table-column v-else :key="index" :prop="item.prop" :label="item.label" :formatter="item.formatter"
              :width="item.width">
            </el-table-column>
          </template>
          <el-table-column label="操作" width="160">
            <template slot-scope="scope" class="tableButton">
              <el-button class="tableBtn" @click="viewOrHandle(scope.row)" type="text" size="small">编辑</el-button>
              <!-- <el-button class="tableBtn" @click="viewOrHandle(scope.row)" type="text" size="small">查看详情</el-button> -->
              <el-button class="tableBtn" @click="deleteFun(scope.row)" type="text" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
        layout="total, prev, pager, next, jumper" :total="totalCount" class="paginationBody">
      </el-pagination>
    </div>
    <!--    新增/编辑弹框-->
    <div class="dialogDiv">
      <el-dialog :title="eventControl" :visible.sync="dialogFormVisible" :before-close="closeData" center>
        <el-form ref="addForm" :model="addForm" :rules="rules" label-width="100px" :disabled="viewShow">
          <el-row>
            <el-col :span="12">
              <el-form-item label="室号" prop="roomName" class="formItem">
                <el-input v-model="addForm.roomName" clearable placeholder="请输入"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="所属园区" prop="parkCode" class="formItem">
                <!-- <el-input v-model="addForm.parkLevel" clearable placeholder="请输入"></el-input> -->
                <el-select v-model="addForm.parkCode" placeholder="请选择" style="width:100%" @change="handleAddParkCode">
                  <el-option v-for="item in basePackInfoList" :key="item.parkCode" :label="item.parkName"
                    :value="item.parkCode">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="所属楼宇" prop="buildingId" class="formItem">
                <el-select v-model="addForm.buildingId" placeholder="请选择" style="width:100%">
                  <el-option v-for="item in buildingList" :key="item.id" :label="item.buildingName" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="面积" prop="area" class="formItem">
                <el-input-number v-model="addForm.area" clearable placeholder="请输入" style="width:70%;text-align: left;"
                  :min="0" :precision="2" :controls="false">
                </el-input-number> 平方米
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="承租状态" prop="rentType" class="formItem">
                <el-select v-model="addForm.rentType" placeholder="请选择" style="width:100%" @change="handleRentType">
                  <el-option v-for="item in rentTypeOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="承租企业" prop="" class="formItem">
                <el-select v-model="addForm.rentCompanyId" placeholder="请选择" style="width:100%" clearable>
                  <el-option v-for="item in baseRenterCompanyList" :key="item.renterId" :label="item.renterCompanyName"
                    :value="item.renterId">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="承租日期"  class="formItem">
                <el-date-picker v-model="addForm.rentStartDate" type="date" placeholder="选择日期" value-format="yyyy-MM-dd">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="到期日期"  class="formItem">
                <el-date-picker v-model="addForm.rentEndDate" style="width:100%" type="date" placeholder="选择日期" value-format="yyyy-MM-dd">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="日租金" prop="rentFee" class="formItem">
                <el-input-number v-model="addForm.rentFee" clearable placeholder="请输入"
                  style="text-align: left;width: 60%;"  :min="0" :precision="2"
                  :controls="false">
                </el-input-number>元/平米/日
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="物业费单价" prop="managementFee" class="formItem">
                <el-input-number v-model="addForm.managementFee" clearable placeholder="请输入" style="width:90%;text-align: left;" :min="0" :precision="2"
                  :controls="false">
                </el-input-number>元
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="是否已交租" prop="officeAreaNoRented" class="formItem">
                <el-select v-model="addForm.hasPayed" placeholder="请选择" style="width:100%">
                  <el-option v-for="item in isHasPayed" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="房屋照片" class="formItem">
            <uploadImg @handleFileImg="handleFileImg" :attachmentUrlList='addForm.attachmentUrl'></uploadImg>
          </el-form-item>
          <el-row>
            <el-col :span="12">
              <el-form-item label="H5待租列表展示" prop="managementOfficePhone" class="formItem">
                  <el-radio v-model="addForm.showOnH5Flag" :label="1">是</el-radio>
                  <el-radio v-model="addForm.showOnH5Flag" :label="0">否</el-radio>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="closeData">取 消</el-button>
          <el-button type="primary" @click="addEventForm()" v-if="!viewShow">保 存</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { baseParkInfo, baseRoomInfoExport, baseRenterCompany, queryBuilding, baseRoomInfo } from '@/api/basicInfo'
import uploadImg from '@/components/upload/uploadImg'
// import { validPassword } from '@/assets/scripts/validate'
import { Message } from 'element-ui'
import moment from 'moment'
export default {
  name: 'accountPage',
  components: {
    uploadImg
  },
  data() {
    return {
      loading: false,
      viewShow: false,
      searchFrom: {
        roomName: "",
        parkCode: "",
        buildingId: "",
        rentType: "",
        rentCompanyId: "",
        buildingAddr: "",
      },
      currentPage: 1,
      totalCount: 0,
      pageSize: 10,
      dialogFormVisible: false,
      eventControl: '',
      edit: false,
      passwordForm: {},
      addForm: {
        roomName: '', // 室号
        parkCode: '', // 所属园区
        buildingId: '', // 所属楼宇
        showOnH5Flag: 1,
        area: '', // 面积
        rentType: '', // 承租状态
        rentCompanyId: '', // 承租公司id
        rentCompanyName: '', // 承租公司名称
        rentStartDate: '', // 承租日期
        rentEndDate: '', // 到期日期
        rentFee: '', // 日租金
        managementFee: '', // 物业费单价
        hasPayed: '', // 是否已交租
        attachmentUrl: '', // 房屋照片
      },
      rules: {
        roomName: [{ required: true, message: '请填写', trigger: 'blur' }],
        buildingId: [{ required: true, message: '请选择', trigger: 'blur' }],
        parkCode: [{ required: true, message: '请选择', trigger: 'blur' }],
        area: [{ required: true, message: '请填写', trigger: 'blur' }],
        rentType: [{ required: true, message: '请选择', trigger: 'blur' }],
        rentStartDate: [{ required: true, message: '请选择', trigger: 'change' }],
        rentEndDate: [{ required: true, message: '请选择', trigger: 'change' }],
      },
      tableData: [],
      isHasPayed: [
        {
          label: '已交租',
          value: true
        },
        {
          label: '未交租',
          value: false
        },
      ],
      rentTypeOptions: [
        {
          label: '待出租',
          value: '待出租'
        },
        {
          label: '已出租',
          value: '已出租'
        },
      ],
      tableColumns: [
        {
          prop: 'roomName',
          label: '室号'
        },
        {
          prop: 'buildingName',
          label: '所属楼宇'
        },
        {
          prop: 'buildingAddr',
          label: '楼宇地址'
        },
        {
          prop: 'parkName',
          label: '园区'
        },
        {
          prop: 'area',
          label: '面积(m²)',
          width: 100
        },
        {
          prop: 'rentFee',
          label: '日租金'
        },
        {
          prop: 'managementFee',
          label: '物业费单价'
        },
        {
          prop: 'rentType',
          label: '承租状态'
        },
        {
          prop: 'hasPayed',
          label: '是否已交租',
          formatter: (row, column, v) => {
            return row.hasPayed ? '已交租' : '未交租'
          }
        },
        {
          prop: 'rentCompanyName',
          label: '承租企业'
        },
        {
          prop: 'rentStartDate',
          label: '承租日期',
          formatter: (row, column, v) => {
            return row.rentStartDate === '1900-01-01' ? '' : row.rentStartDate
          }
        },
        {
          prop: 'rentEndDate',
          label: '到期日期',
          formatter: (row, column, v) => {
            return row.rentEndDate === '1900-01-01' ? '' : row.rentEndDate
          }
        }
      ],
      basePackInfoList: [],
      baseRenterCompanyList: [],
      buildingList: [],
    }
  },
  watch: {
    'searchFrom.parkCode': {
      handler: function (val) {
        if (val === '') {
          this.searchFrom.buildingId = ''
        }
      }
    },
    // 'addForm.rentEndDate': {
    //   handler: function (val) {
    //     console.log(val);
    //     let dateMin = moment(this.addForm.rentEndDate)
    //     let dateMax = moment(new Date())
    //     let time = dateMax.diff(dateMin, 'months')
    //     console.log(time);
    //   }
    // },
    // 'addForm.rentType': {
    //   handler: function (val) {
    //     if (val === '待出租') {
    //       this.addForm.rentCompanyId = '' // 承租公司id
    //       this.addForm.rentCompanyName = '' // 承租公司名称
    //       this.addForm.rentStartDate = '' // 承租日期
    //       this.addForm.rentEndDate = '' // 到期日期
    //       this.addForm.rentFee = '' // 日租金
    //       this.addForm.managementFee = '' // 物业费单价
    //       this.addForm.hasPayed = '' // 是否已交租
    //       this.addForm.attachmentUrl = '' // 房屋照片
    //     }
    //   }
    // }
  },
  mounted() {
    this.getData()
    // 园区接口
    this.baseParkList()
    // 承租企业
    this.baseRenterList()
  },
  methods: {
    handleRentType(val) {
      console.log(val);
      if (val === '待出租') {
          this.addForm.rentCompanyId = '' // 承租公司id
          this.addForm.rentCompanyName = '' // 承租公司名称
          this.addForm.rentStartDate = '' // 承租日期
          this.addForm.rentEndDate = '' // 到期日期
          this.addForm.rentFee = '' // 日租金
          this.addForm.managementFee = '' // 物业费单价
          this.addForm.hasPayed = '' // 是否已交租
          this.addForm.attachmentUrl = '' // 房屋照片
        }
    },
    async exportBuildData() {
            let res = await baseRoomInfoExport('export', {
                ...this.searchFrom
            })
            const blob = new Blob([res], { type: "application/vnd.ms-excel" });
            const elink = document.createElement("a");
            elink.download = '房屋管理' + moment().format('YYYYMMDD') + '.xls';
            elink.style.display = "none";
            elink.href = URL.createObjectURL(blob);
            document.body.appendChild(elink);
            elink.click();
            URL.revokeObjectURL(elink.href);
            document.body.removeChild(elink);
        },
    getMonthsNum(row) {
      if (row.rentType === '已出租') {
        let dateMax = moment(row.rentEndDate)
        let dateMin = moment(new Date()).format('YYYY-MM-DD')
        let rentMounth = row?.rentEndDate?.split('-')[1] || 0
        let newMounth = moment(new Date()).format('YYYY-MM-DD')?.split('-')[1] || 0
        let rentYear = row?.rentEndDate?.split('-')[0] || 0
        let newYear = moment(new Date()).format('YYYY-MM-DD')?.split('-')[0] || 0

        if (Number(rentYear) < Number(newYear)) {
          return {
            num: -1,
          }
        }
        if (Number(rentYear) === Number(newYear)) {
          if (Number(rentMounth) < Number(newMounth)) {
            return {
              num: -1,
            }
          }
          if (Number(rentMounth) === Number(newMounth)) {
            let days = dateMax.diff(dateMin, 'days')
            return {
              num: days,
              type: 'day'
            }
          }
          if (Number(rentMounth) > Number(newMounth)) {
            let months = dateMax.diff(dateMin, 'months')
            return {
              num: months,
              type: 'month'
            }
          }
        }
        if (Number(rentYear) > Number(newYear)) {
          console.log(row);
          let dt1 = row.rentEndDate
          let dt2 = dateMin
          dt1 = dt1.split('-')
          dt1 = parseInt(dt1[0]) * 12 + parseInt(dt1[1])
          dt2 = dt2.split('-')
          dt2 = parseInt(dt2[0]) * 12 + parseInt(dt2[1])
          let mounth = Math.abs(dt1 - dt2)
          return {
            num: mounth,
            type: 'month'
          }
        }
      } else {
        return {
            num: -1,
        }
      }
    },
    handleFileImg(imgs) {
      let arrUrl = imgs.map(v => v.code)
      this.addForm.attachmentUrl = arrUrl.join(',')
    },
    async baseParkList() {
      const { result } = await baseParkInfo('query', {
        pageNum: 1,
        pageSize: 999
      })
      this.basePackInfoList = result.records
    },
    async baseRenterList() {
      const { result } = await baseRenterCompany('query', {
        pageNum: 1,
        pageSize: 999
      })
      this.baseRenterCompanyList = result.records
    },
    async handleParkCode(val) {
      const { result } = await queryBuilding({
        parkCode: val,
        pageNum: 1,
        pageSize: 999
      })
      this.buildingList = result.records
    },
    handleAddParkCode(val) {
      this.handleParkCode(val)
      this.addForm.buildingId = ''
    },
    getData() {
      this.currentPage = 1
      this.queryList()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.queryList()
    },
    async queryList() {
      let res = await baseRoomInfo('query', {
        roomName: this.searchFrom.roomName,
        parkCode: this.searchFrom.parkCode,
        buildingId: this.searchFrom.buildingId,
        rentType: this.searchFrom.rentType,
        rentCompanyId: this.searchFrom.rentCompanyId,
        buildingAddr: this.searchFrom.buildingAddr,
        pageNum: this.currentPage,
        pageSize: this.pageSize
      })
      if (res.code === 0) {
        this.tableData = res.result.records
        this.totalCount = res.result.total
      }
    },
    addFormData() {
      this.edit = false
      this.dialogFormVisible = true
      this.eventControl = '新增房屋'
    },
    async viewOrHandle(row) {
      this.edit = true
      this.eventControl = '编辑房屋'
      this.newOldFormContrast(row)
      this.dialogFormVisible = true
    },
    async viewOrHandleDetail(row) {
      this.edit = true
      this.viewShow = true
      this.eventControl = '查看详情'
      this.newOldFormContrast(row)
      this.dialogFormVisible = true
    },
    newOldFormContrast(newForm) {
      Object.keys(this.addForm).forEach(key => {
        this.addForm[key] = newForm[key]
      })
      this.handleParkCode(newForm.parkCode)
      this.addForm.id = newForm.id
      if (newForm.rentStartDate === '1900-01-01') {
        this.addForm.rentStartDate = ''
      }
      if (newForm.rentEndDate === '1900-01-01') {
        this.addForm.rentEndDate = ''
      }
      console.log(this.addForm, 'q1qqqq');
    },
    closeData() {
      this.dialogFormVisible = false
      this.viewShow = false
      this.$refs['addForm'].resetFields()
      this.addForm = this.$options.data.call(this).addForm
    },
    addEventForm() {
      this.$refs['addForm'].validate(async (valid) => {
        if (valid) {
          if (this.addForm.rentStartDate === null) {
            this.addForm.rentStartDate = ''
          }
          if (this.addForm.rentEndDate === null) {
            this.addForm.rentEndDate = ''
          }
          let companyObj = this.baseRenterCompanyList.find(i => i.renterId === this.addForm.rentCompanyId)
          this.addForm['rentCompanyName'] = companyObj && companyObj.renterCompanyName ? companyObj.renterCompanyName : ''
          if (this.edit) {
            let res = await baseRoomInfo('update', this.addForm)
            if (res.code === 0) {
              Message.success('编辑成功！')
              this.closeData()
              await this.getData()
            } else {
              Message.warning({ message: res.message })
            }
          } else {
            let res = await baseRoomInfo('add', this.addForm)
            if (res.code === 0) {
              Message.success('新增成功！')
              this.closeData()
              await this.getData()
            } else {
              Message.error(res.message)
            }
          }
        }
      })
    },
    // 删除
    deleteFun(row) {
      this.$confirm('此操作将删除当前数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        let params = {
          'id': row.id
        }
        let res = await baseRoomInfo('deleteById', params)
        if (res.code === 0) {
          Message.success('删除成功！')
        } else {
          Message.error(res.message)
        }
        await this.getData()
      })
    },
    getSummaries(param) {
      const totalArea = this.tableData?.[0]?.totalArea || 0
        return ['汇总', '', '', '', totalArea + 'm²'];
      }
  }
}
</script>

<style lang="scss" scoped>
.app-inner {
  width: 98%;
  height: 70vh;
  padding: 0.2rem;
  box-sizing: border-box;
}

.searchTitleDiv {
  width: 15rem;
  // height: 0.66rem;
  margin-left: 0.2rem;
  margin-top: 0.05rem;
  /*display: flex;*/
  /*justify-content: space-around;*/

  .stateDiv {
    margin-top: 0.14rem;
    margin-left: .3rem;
    float: left;
  }

  .searchText {
    margin-top: 0.05rem;
    margin-right: 0.13rem;
    font-size: 0.2rem;
    color: #111111;
    float: left;
  }

  .inputDiv {
    width: 2.2rem;
    float: left;
  }

  .searchBtn {
    /*width: 1.20rem;*/
    /*height: 0.36rem;*/
    /*border-radius: 0.06rem;*/
    /*font-size: 0.18rem;*/
    margin-top: 0.14rem;
    margin-left: .3rem;
    /*padding-top: 0.1rem;*/
  }
}

.table {
  margin-top: .3rem;
  margin-left: .5rem;
  text-align: center;
  width: 14.8rem;

  .searchList {}

  .paginationBody {
    margin-top: .1rem;
  }
}

.formItem {
  // width: 3.2rem;
}

/deep/ .el-dialog {
  width: 50% !important;
}
</style>
